import { Button } from '@atoms'
import { useDialog } from '@components/DialogProvider'
import { scopedTranslation } from '@frontend/utils/I18n'

const t = scopedTranslation('calling_sessions_index')

type ArchiveCallingSessionButtonProps = {
  session: {
    id: string
    name: string | null
  }
}

export function ArchiveCallingSessionButton({ session }: ArchiveCallingSessionButtonProps) {
  const { open: openDialog } = useDialog()
  const sessionName = session.name ?? ''

  return (
    <Button
      rank="secondary"
      size="sm"
      color="danger"
      leadingIcon="archive"
      ariaLabel={t('actions.archive_session', { name: sessionName })}
      onClick={() =>
        openDialog({
          type: 'archiveCallingSession',
          dialogData: { callingSessionId: session.id, sessionName },
        })
      }
    >
      {t('actions.archive')}
    </Button>
  )
}
